import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import Select from "react-select";
import { useUpdateFacturationMode } from '../../../hooks/TICKET/useUpdateFacturationMode';
import { useColors } from '../../../hooks/COLORS/useColors';
import { customSelectStyles } from '../../../utils/reactSelectStyles';

const UpdateFacturationMode = ({ showUpdateFacturationMode, setShowUpdateFacturationMode, mode }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({ label: '', couleur: null, defaut: false });

    const { mutateAsync: updateMode } = useUpdateFacturationMode();
    const { data: colorsData, isLoading: isLoadingColors } = useColors();

    const colorOptions = colorsData?.data?.map(color => ({ value: color.id.toString(), label: color.name })) ?? [];

    useEffect(() => {
        if (mode) {
            setFormData({
                label: mode.label || '',
                couleur: mode.color?.id ? { value: mode.color.id.toString(), label: mode.color.name } : null,
                defaut: mode.is_default || false
            });
        }
    }, [mode]);

    const hasChanges = mode && (
        formData.label !== (mode.label || '') ||
        (formData.couleur?.value ?? null) !== (mode.color?.id?.toString() ?? null) ||
        formData.defaut !== (mode.is_default || false)
    );

    const formatColorOption = ({ label, hex }) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{ width: '14px', height: '14px', borderRadius: '50%', backgroundColor: hex || '#e9ecef', border: '1px solid #ced4da', flexShrink: 0 }} />
            <span>{label}</span>
        </div>
    );

    const handleSubmitForm = async (e) => {
        e.preventDefault();
        if (!hasChanges) { setShowUpdateFacturationMode(false); return; }

        const modeData = {};
        if (formData.label !== (mode.label || '')) modeData.label = formData.label;
        if ((formData.couleur?.value ?? null) !== (mode.color?.id?.toString() ?? null)) {
            modeData.couleur = formData.couleur ? parseInt(formData.couleur.value) : null;
        }
        if (formData.defaut !== (mode.is_default || false)) modeData.defaut = formData.defaut;

        setIsSubmitting(true);
        try {
            await updateMode({ modeId: mode.id, modeData });
            setShowUpdateFacturationMode(false);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal show={showUpdateFacturationMode} onHide={() => setShowUpdateFacturationMode(false)} size='md'>
            <Form onSubmit={handleSubmitForm}>
                <Modal.Header closeButton>
                    <Modal.Title><h5 className='text-muted modal-title'>Modifier la méthode de facturation</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="idLabel">
                        <Form.Label className='text-muted'>Label</Form.Label>
                        <Form.Control type="text" placeholder="Label" value={formData.label} onChange={(e) => setFormData({ ...formData, label: e.target.value })} />
                    </Form.Group>
                    <Form.Group className='mb-3' controlId="idCouleur">
                        <Form.Label className='text-muted'>Choisissez une couleur</Form.Label>
                        <Select options={colorOptions} value={formData.couleur} formatOptionLabel={formatColorOption} onChange={(option) => setFormData({ ...formData, couleur: option })} isLoading={isLoadingColors} menuPortalTarget={document.body} styles={{ ...customSelectStyles, menuPortal: base => ({ ...base, zIndex: 9999 }) }} placeholder="Sélectionnez une couleur" isClearable />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="idDefaut">
                        <Form.Check type="checkbox" label="Méthode par défaut" checked={formData.defaut} onChange={(e) => setFormData({ ...formData, defaut: e.target.checked })} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" disabled={isSubmitting} onClick={() => setShowUpdateFacturationMode(false)}>Annuler</Button>
                    <Button variant="primary" type="submit" disabled={isSubmitting || !hasChanges}>
                        {isSubmitting ? 'Chargement...' : 'Modifier'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default UpdateFacturationMode;